import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import {
	ValidateTokenResponse,
	BearerTokenResponse,
	SubmittedResponse,
} from './types/self-certification-api.models';

@Injectable()
export class SelfCertificationApiService {
	private get baseUrl(): string {
		return `${environment.onboardingApiUrl}/self-certification`;
	}

	async validateToken(token: string): Promise<ValidateTokenResponse> {
		const res = await fetch(
			`${this.baseUrl}/validate-token/${encodeURIComponent(token)}`
		);
		const body = await res.json();

		if (!res.ok) throw body;

		return body;
	}

	async getBearerToken(token: string): Promise<BearerTokenResponse> {
		const res = await fetch(
			`${this.baseUrl}/bearer-token/${encodeURIComponent(token)}`
		);
		const body = await res.json();

		if (!res.ok) throw body;

		return body;
	}

	/**
	 * Tells the backend the TaxBit SDK failed, so the failure is visible server-side.
	 * Pass a plain message only — the raw SDK error wraps the request that carries the bearer token.
	 */
	async reportSdkError(token: string, message: string): Promise<void> {
		await fetch(`${this.baseUrl}/sdk-error/${encodeURIComponent(token)}`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ message }),
		});
	}

	async notifySubmitted(token: string): Promise<SubmittedResponse> {
		const res = await fetch(
			`${this.baseUrl}/submitted/${encodeURIComponent(token)}`,
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
			}
		);
		const body = await res.json();

		if (!res.ok) throw body;

		return body;
	}
}
